export var BAR_HEIGHT = 16;
export var BORDER_WIDTH = 2;